import React from 'react'

import facebook from '../assets/icons/facebook.svg'
import instagram from '../assets/icons/instagram.svg'
import github from '../assets/icons/github.svg'
import pin from '../assets/icons/pin.svg'
import tie from '../assets/icons/tie.svg'
import profilepic from '../assets/icons/profilepic.jpg'
import resume from '../assets/Resume-Caleb Ruto.docx'
import { motion }from 'framer-motion'

const sidebar = () =>{
    const handleEmailMe = () =>{
        window.open("mailto: calebruto45@gmail.com")
    }
    const sidebar_variants = {
        hidden : {
            x :'-20vw',

        },
        visible : {
            x: 0,
            transition : {
                delay: 0.1, transition:0.5, type: 'spring'
        }
        }
    }

    return(
        <motion.div className="sidebar"
            variants = {sidebar_variants}
            initial = 'hidden'
            animate = 'visible'
        >
        <img src={profilepic} alt="Sidebar" className="Sidebar__avatar"/>
        <div className="sidebar__name">Caleb <span>Ruto</span></div>
        <div className="sidebar__item  sidebar__title">Web Developer</div>
        <a href={resume} download='Resume-Caleb Ruto.docx'>
            <div className="sidebar__item sidebar__resume">
                <img src={tie} alt="resume" className="sidebar__icon"/>Download Resume
            </div>
        </a>
        <figure className="sidebar__social-icons my-2">
            <a href="#!"><img src={facebook} alt="facebook" className="sidebar__icon mr-3"/></a>
            <a href="#!"><img src={instagram} alt="instagram" className="sidebar__icon"/></a>
        </figure>
        <div className="sidebar__contact">
            <div className="sidebar__item sidebar_github">
                <a href="#!"><img src={github} alt="github" className="sidebar__icon mr-3"/>github</a>
            </div>
            <div className="sidebar__location">
                <img src={pin} alt="location" className="sidebar__icon mr-3"/>
                Nairobi,Kenya</div>  
            <div className="sidebar__item">calebruto45@gmail.com</div>
            <div className="sidebar__item">+(254)708827196</div>
        </div>
            <div className="sidebar__item sidebar__email" onClick={handleEmailMe}>email me</div>
        </motion.div>
    )
}
export default sidebar;